

import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import { Getter, namespace, State } from "vuex-class"

import { DataSource } from "@/types"
import SourceSearch from "@/components/Config/Sources/SourceSearch.vue"
import SourceEdit from "./SourceEdit.vue"
import { cloneDeep } from "lodash"

const setup = namespace("setup")

@Component({
	components: {
		"source-search": SourceSearch,
		"source-edit": SourceEdit
	}
})
export default class Source extends Vue {
	@setup.Getter("getDataSources")
	public dataSources!: DataSource[] | null

	editSource: DataSource | null = null

	get dataSourceId (): string | null {
		return this.$route.params ? this.$route.params["dataSourceId"] : null
	}

	get dataSource (): DataSource | null {
		if (!this.dataSources) return null
		return this.dataSources.find(d => d.id === this.dataSourceId) || null
	}

	editDataSource (editSource: DataSource) {
		this.editSource = cloneDeep(editSource)
	}

	created (newItem: DataSource) {
		if (newItem.id) {
			this.$emit("created", newItem)
		}
	}

	removed (removedItem: DataSource) {
		if (removedItem.id && this.dataSources && this.dataSources.length > 0) {
			this.$router.push({ path: `/configuration/data-source/${this.dataSources![0].id}` })
		}
	}
}

